import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser, Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, inject, PLATFORM_ID, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MultiCartFacade } from '@spartacus/cart/base/root';
import {
  AuthService,
  BaseSiteService,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  OccConfig,
  Page,
  RoutingService,
} from '@spartacus/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { catchError, distinctUntilChanged, filter, first, shareReplay, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';
import { CookieService } from 'src/app/customServices/cookie.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { ForgotPasswordService } from 'src/app/services/feature/forgot-pwd/forgot-password.service';
import { MyAccountService } from 'src/app/services/feature/MyAccount/my-account.service';
import { SignalMessageService } from 'src/app/services/feature/signal-msg/signal-message.service';
import { KbCurrencyService } from 'src/app/services/sapSpartacus/kbCurrencyService/kbCurrency-service.service';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';
import { CountryService } from '../site-context-selector/country.service';
import { CartActions, StateWithMultiCart } from '@spartacus/cart/base/core';
import { Store } from '@ngrx/store';
import { SessionMessageStorageService } from '../../services/feature/session-message/kb-session-message.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  private messageSessionService = inject(SessionMessageStorageService);
  //for unsubscribing
  signal$: Observable<any>;
  private unsubscribe$ = new Subject<void>();
  isLoggedIn: boolean;
  countryIsoCode: string;
  languageIsoCode: string;
  MediaUrl: string;
  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';
  displayIsocodes: string[] = [];
  baseSite: string;
  showContent: boolean = false;
  currentOne: any;
  options: any[];
  selectedOption: any;
  userSelectedSoldToData: any;
  firstname: string;
  lastname: string;
  iscustomerIdCookieSet: boolean = false;
  cookiesData: any;
  isCustSelector: boolean = false;
  mobileNavToggle: boolean = false;
  showSearch: boolean = false;
  isCheckoutPage: boolean = false;
  isMobile: boolean;
  signalMsg: any;
  signalShow: boolean = false;
  showMyAcc: boolean = false;
  subscription: any;
  //creating a local instance to keep the cartId in order to load the cart from setallThree wrapper
  currentCartId: string;
  headerDataUserSelected: boolean = true;
  // to avoid unneccesary Api calls
  canCallLang: boolean = true;
  canCallHeaderData: boolean = true;
  disableMobBreadcrumb = false;

  @ViewChild('header') header: ElementRef;
  scrollableHeader: boolean = false;
  platformId = inject(PLATFORM_ID);
  currentUrl = isPlatformBrowser(this.platformId) ? window.location.href : '';
  private observer!: MutationObserver;

  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(
    private authService: AuthService,
    private baseSiteService: BaseSiteService,
    private cookieService: CookieService,
    public custIDService: CustomerIdService,
    private langService: KBLanguageService,
    private currencyService: KbCurrencyService,
    protected routingService: RoutingService,
    private forgotPwdService: ForgotPasswordService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    protected globalMessage: GlobalMessageService,
    private renderer: Renderer2,
    private checkoutService: KbCheckOutService,
    public breakpointObserver: BreakpointObserver,
    private multiCartService: MultiCartFacade,
    private signalMessageService: SignalMessageService,
    private countryService: CountryService,
    private location: Location,
    private leftsideNav: MyAccountService,
    protected store: Store<StateWithMultiCart>,
    protected cmsService: CmsService,
    private config: OccConfig,
    private el: ElementRef,
  ) {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.unsubscribe$)).subscribe((result) => {
      this.isMobile = result.matches;
    });
    const oldGo = this.routingService.go.bind(this.routingService);
    this.routingService.go = (...args: any[]) => {
      console.trace('ROUTING SERVICE GO', args);
      return oldGo(...args);
    };
  }

  ngDoCheck() {
    this.multipleTabCustId();
    this.cdr.detectChanges();
  }

  ngOnInit() {
    console.log('CURRENT URL', this.router.url);
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        console.log('ROUTE CHANGED', e.urlAfterRedirects);
      });
    this.authService
      .isUserLoggedIn()
      .pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.isLoggedIn = data;
        if (this.isLoggedIn) {
          this.getCustomerIds();
          this.callApiOnLangChange();
        } else {
          this.showContent = false;
          this.isCustSelector = false;
        }
      });
    this.langService.canLoadCart$.pipe(takeUntil(this.unsubscribe$)).subscribe((can: boolean) => {
      if (can) {
        this.updateUserCart();
      }
    });
    //for hiding search dropdown in mobile view
    this.subscription = this.location.onUrlChange((url: String) => {
      if (url) {
        this.showContent = false;
        this.showSearch = false;
        if (this.isMobile) {
          this.showMyAcc = false;
          this.mobileNavToggle = false;
          this.multipleTabCustId();
        }
      }
    });
    //for hidingMYACC
    this.leftsideNav.canClose.pipe(takeUntil(this.unsubscribe$)).subscribe((canclose) => {
      this.showMyAcc = canclose;
    });

    //checking whether we are in checkout page or not
    this.checkoutService.isCheckOut$.pipe(takeUntil(this.unsubscribe$)).subscribe((isItCheckoutPage) => {
      if (isItCheckoutPage) {
        this.isCheckoutPage = isItCheckoutPage;
        this.cdr.detectChanges();
      } else {
        this.isCheckoutPage = false;
      }
    });
    this.baseSiteService.getActive().pipe(takeUntil(this.unsubscribe$)).subscribe((baseSiteName) => {
      this.baseSite = baseSiteName;
    });

    //this.setNewCountry();
    this.getSignalMsg();
    this.cmsService
      .getCurrentPage()
      .pipe(
        filter<Page>(Boolean),
        tap((cmsPage) => {
          switch (cmsPage?.pageId) {
            case 'homepage':
              this.disableMobBreadcrumb = true;
              break;
            default:
              this.disableMobBreadcrumb = false;
              break;
          }
        })
      )
      .subscribe();
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.listen('document', 'click', (event) => {
        const clickedInside = (event.target as HTMLElement).innerText;
        if (clickedInside == 'SIGN OUT') {
        }
      });
      this.renderer.listen('window', 'scroll', (event) => {
        const rect = this.header.nativeElement.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (isVisible) {
          this.scrollableHeader = false;
        } else {
          this.scrollableHeader = true;
        }
      });
    }
    if (isPlatformBrowser(this.platformId)) {
      this.initMutationObserver();
    }
  }
  private initMutationObserver(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.observer = new MutationObserver(() => {
        const buttons = document.querySelectorAll(
          '#cx-header cx-navigation-ui.flyout > nav > ul > li > button[title]'
        );

        if (buttons?.length) {
          buttons.forEach((btn: Element) => {
            this.renderer.removeAttribute(btn, 'title');
          });
          // this.observer.disconnect();
        }
      });

      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId)) {
      const elements = document.querySelectorAll('cx-navigation-ui.flyout > nav > ul > li');
      elements.forEach(element => {
        this.renderer.listen(element, 'mouseenter', () => {
          if (!this.isMobile) {
            this.applyHoverEffect();
          }
        });
      });
    }
  }
  //To set the minimum height of nav 
  applyHoverEffect() {
    const listItems = this.el.nativeElement.querySelectorAll('cx-navigation-ui.flyout > nav > ul > li');
    listItems.forEach((li: HTMLElement) => {
      this.renderer.listen(li, 'mouseover', () => {
        const wrapper = li.querySelector('.wrapper') as HTMLElement;
        if (wrapper) {
          const height = wrapper.offsetHeight;
          const targetItems = this.el.nativeElement.querySelectorAll('cx-navigation-ui nav ul.childs > li .wrapper');
          targetItems.forEach((targetWrapper: HTMLElement) => {
            this.renderer.setStyle(targetWrapper, 'min-height', `${height}px`);
          });
        }
      });
    });
  }
  callApiOnLangChange() {
    this.langService
      .getActive()
      .pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$))
      .subscribe((lang: any) => {
        this.multipleTabCustId();
        if (this.canCallLang) {
          this.showContent = false;
          this.custIDService
            .getAllCustomerId()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((apiResponse: any) => {
              this.options = apiResponse?.b2bUnitsWSList;
              this.multiCartService.reloadCart(this.currentCartId, { active: true });
            });
        }
      });
  }
  multipleTabCustId() {
    const isCustomerIdCookieSet = this.cookieService.isCookieSet('customerIdNA');
    if (isCustomerIdCookieSet) {
      const custId = this.cookieService.getCookieValue('customerIdNA');
      if (this.options !== undefined) {
        this.options.find((x) => {
          if (x?.uid === custId) {
            this.custIDService.theCurrentCustomerIdState$.next(x);
          }
        });
      }
    }
  }
  getCustomerIds() {
    this.canCallLang = false;
    this.custIDService
      .getAllCustomerId()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((x: any) => {
        if (x) {
          this.custIDService.fleetPrideGroup$.next(!x?.isFleetPrideGroup);
          this.custIDService.customerIdData = x;
          this.options = x?.b2bUnitsWSList;
          const current = x?.b2bUnitsWSList;
          const name = x?.userWS;
          this.custIDService.onlineOrdering$.next(x?.userWS?.onlineOrdering);
          this.custIDService.showCorePrice$.next(x?.userWS?.showCorePrice);
          this.custIDService.showNetPrice$.next(x?.userWS?.showNetPrice);
          this.custIDService.showListPrice$.next(x?.userWS?.showListPrice);
          const ispwdExp = x?.isPwdExpiredWSDTO?.isPwdExpired;
          const status = x?.kbStatusMessageWSDTO;
          this.multipleTabCustId();
          //Checking whether the user is logging in after 365 days
          if (ispwdExp) {
            this.setCustomerDataFirst(name, x, current);
            this.router.navigate(['securePassword']);
          }
          //checking whether the user default sold to is not matching
          else if ((status?.status == 'ERROR' && status?.message == 'common.text_company_manage_units_notapproved') || (status?.status == 'ERROR' && status?.message == 'common.login_error_account_not_found_title')) {
            this.messageSessionService.setMessage(GlobalMessageType.MSG_TYPE_ERROR, status?.message);
            this.forgotPwdService.deleteRefreshTokenCookie();
            this.authService.coreLogout().then(() => {
              this.routingService.go({ cxRoute: 'login' });
            });
            //this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
            // this.router.navigate(['/login']);
            return;
          }
          //if the user is proper without any issues
          else {
            this.setCustomerDataFirst(name, x, current);
          }
          //to avoid unwanted api calls
          this.canCallHeaderData = false;
          this.canCallLang = true;
          this.updateUserCartOnStoreChange('init');
        }
      });
  }
  onChildValueChange(value: any) {
    this.selectedOption = value;
    this.checkCrossDomain(value);
    this.headerDataUserSelected = false;

  }
  //method to check crossdomain scenario
  checkCrossDomain(selectedId) {
    this.options.find((user) => {
      if (user.uid === selectedId.uid) {
        if (user?.crossDomain) {
          this.showContent = false;
          console.trace('HEADER REDIRECT TO HOME checkCrossDomain');
          this.routingService.go({ cxRoute: 'home' });
        } else {
          this.userSelectedSoldToData = user?.storeDetails;
          this.setNewCustomerId();
        }
      }
    });
  }
  //updating customer Id on selection from dropdown
  setNewCustomerId() {
    console.trace('HEADER REDIRECT TO HOME setNewCustomerId');
    this.routingService.go({ cxRoute: 'home' });
    const customerId = {
      customerIdNA: this.selectedOption.uid,
      defaultCurrencyNA: this.selectedOption?.storeDetails?.defaultCurrency?.isocode,
      countryIsoCodeNA: this.selectedOption?.storeDetails?.countryIsoCode,
      languageIsoCodeNA: this.selectedOption?.storeDetails?.defaultLanguage.isocode,
    };
    this.cookieService.setCookies(customerId);
    this.setSelectedSoldToData(this.userSelectedSoldToData, customerId);
  }
  updateUserCartOnStoreChange(source?) {
    this.timeout = setTimeout(() => {
      this.custIDService
        .setSpecificCustomerId()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: any) => {
          if (res && res?.userWSDTO?.cartId) {
            this.currentCartId = res?.userWSDTO?.cartId;
            if (source === 'init') {
              this.multiCartService.reloadCart(this.currentCartId, { active: true });
            } else {
              this.store.dispatch(new CartActions.SetActiveCartId(this.currentCartId));
              this.multiCartService.reloadCart(this.currentCartId, { active: true });
            }
          }
        });
    }, 1000);
  }
  updateUserCart() {
    if (this.isLoggedIn) {
      this.timeout = setTimeout(() => {
        this.store.dispatch(new CartActions.SetActiveCartId(this.currentCartId));
        this.langService.canLoadCart$.next(false);
      }, 90);
    }
  }
  //custom method to set data of the selected  by customers
  setSelectedSoldToData(x, customerId) {
    this.showContent = !this.showContent;
    this.cookiesData = {
      countryIsoCodeNA: x.countryIsoCode,
      displayIsoCodeNA: x?.defaultLanguage?.displayIsoCode,
      defaultCurrencyNA: x?.defaultCurrency?.isocode,
      cartIdNA: this.currentCartId,
      languageIsoCodeNA: x?.defaultLanguage?.isocode,
    };
    this.options.find((x) => {
      if (x.uid === this.selectedOption.uid) {
        this.currentOne = x;
        this.custIDService.theCurrentCustomerIdState$.next(x);
      }
    });
    this.custIDService.currentCustId.next(customerId.customerIdNA);
    this.cookieService.setCookies(this.cookiesData);
    this.currencyService.setAllThree(x.countryIsoCode, x.defaultLanguage?.isocode, x.defaultCurrency?.isocode);
    this.headerDataUserSelected = true;
    this.multipleTabCustId();
    this.updateUserCartOnStoreChange();
    //this.setNewCountry();
  }
  // Setting the customer id for the very first time while making initial header data api call
  setCustomerDataFirst(name, x, current) {
    if (!name)
      return;
    this.isCustSelector = true;
    this.firstname = name?.firstName;
    this.lastname = name?.lastName;
    this.currentCartId = null;
    this.currentCartId = name?.cartId;

    this.multiCartService.reloadCart(name?.cartId, { active: true });
    if (!current) {
      return;
    }
    if (this.cookieService.isCookieSet('customerIdNA')) {
      const custId = this.cookieService.getCookieValue('customerIdNA');
      current.find((org) => {
        if (org.uid === custId) {
          this.currentOne = org;
          this.custIDService.theCurrentCustomerIdState$.next(org);
          this.setCurrentOrganization(org, false);
        }
      });
    } else {
      current?.find((org) => {
        if (org.selected) {
          this.currentOne = org;
          this.custIDService.theCurrentCustomerIdState$.next(org);
          const customerId = {
            customerIdNA: this.currentOne.uid,
          };
          this.cookieService.setCookies(customerId);
          this.custIDService.currentCustId.next(customerId.customerIdNA);
          this.setCurrentOrganization(org, true);
        }
      });
    }
  }

  setCurrentOrganization(currentOne, state) {
    if (state) {
      this.cookiesData = {
        countryIsoCodeNA: currentOne?.storeDetails?.countryIsoCode,
        displayIsoCodeNA: currentOne?.storeDetails?.defaultLanguage?.displayIsoCode,
        defaultCurrencyNA: currentOne?.storeDetails?.defaultCurrency?.isocode,
        languageIsoCodeNA: currentOne?.storeDetails?.defaultLanguage?.isocode,
      };
      this.cookieService.setCookies(this.cookiesData);
      if (this.headerDataUserSelected) {
        this.currencyService.setAllThree(
          currentOne?.storeDetails?.countryIsoCode,
          currentOne?.storeDetails?.defaultLanguage?.displayIsoCode,
          currentOne?.storeDetails?.defaultCurrency?.isocode
        );
      }
    }
  }

  mobileNav() {
    this.mobileNavToggle = !this.mobileNavToggle;
    this.showSearch = false;
    this.showMyAcc = false;
  }

  showSerch() {
    this.showSearch = !this.showSearch;
    this.mobileNavToggle = false;
    this.showMyAcc = false;
    this.cdr.detectChanges();
  }

  getSignalMsg() {
    this.signalMsg = '';
    this.langService.getActive()
      .pipe(
        distinctUntilChanged(),
        takeUntil(this.unsubscribe$),
        switchMap(() => this.countryService.getActive().pipe(take(1))),
        switchMap((country) => this.signalMessageService.getSignalMsg(country)),
      )
      .subscribe((x: any) => {
        if (x.message) {
          this.signalShow = true;
          this.signalMsg = x.message;
        } else {
          this.signalShow = false;
        }
      });
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.subscription && this.subscription instanceof Subscription) {
      this.subscription.unsubscribe();
    }
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
  showMyAccountTab() {
    if (this.isLoggedIn) {
      this.showMyAcc = !this.showMyAcc;
      this.mobileNavToggle = false;
      this.showSearch = false;
    } else {
      this.routingService.go({ cxRoute: 'login' });
    }
  }
}
